






























































































































import { computed, defineComponent, watch } from '@vue/composition-api';
import { getLearningProgramsStore } from '@front-app/modules/learningPrograms/store/LearningProgramsStore';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import { useIsError, useIsLoading } from '@front-app/hooks/useAsyncStatus';
import LoaderState from '@front-app/components/LoaderState.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Location } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { htmlToText } from '@front-app/util/content';
import AsyncSpeakerList from '@front-app/modules/learningPrograms/components/AsyncSpeakerList.vue';
import LearningMeta from '@front-app/modules/learningPrograms/components/LearningMeta.vue';
import BackButton from '@front-app/components/buttons/BackButton.vue';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { getIsCompleted, isModulePublished, isProgramPublished } from '@front-app/modules/learningPrograms/util/util';
import SuccessCheckmark from '@front-app/components/icons/SuccessCheckmark.vue';
import CompletedBadge from '@front-app/modules/learningPrograms/components/CompletedBadge.vue';

export default defineComponent({
	components: {
		PaddedContent,
		ErrorCard,
		LoaderState,
		SimpleCard,
		AsyncSpeakerList,
		LearningMeta,
		BackButton,
		SuccessCheckmark,
		CompletedBadge,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		programId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const programsStore = getLearningProgramsStore();
		const isCompleted = getIsCompleted(programsStore);
		watch(() => props.groupId, () => {
			programsStore.fetchProgram(props.programId, false, CurrentUserStore.isCsr.value);
		}, { immediate: true });
		const program = computed(() => programsStore.getProgram(props.programId));
		// The filtering is only necessary for admins, actually
		const modules = computed(() => program.value.modules.map(programsStore.getModule));
		const isLoadingProgram = computed(() => useIsLoading(programsStore.getProgramStatus(props.programId)).value);
		// The !isProgramPublished logic is only necessary for admins
		const isErrorProgram = computed(() => useIsError(programsStore.getProgramStatus(props.programId)).value || !isProgramPublished(program.value));
		const learningProgram = computed(() => programsStore.getProgram(props.programId));
		const toModule = (moduleId: string): Location => ({ name: Routes.GROUP_LEARNING_MODULE, params: { moduleId } });

		return {
			learningProgram,
			modules,
			toModule,
			isLoadingProgram,
			isErrorProgram,
			isModulePublished,
			// Util
			htmlToText,
			startButtonPalette: ButtonPalettes.SUCCESS,
			toPrograms: { name: Routes.GROUP_LEARNING_PROGRAMS_LIST },
			isCompleted,
		};
	},
});
